import { render, staticRenderFns } from "./levChart.vue?vue&type=template&id=04a841e6&scoped=true"
import script from "./levChart.vue?vue&type=script&lang=js"
export * from "./levChart.vue?vue&type=script&lang=js"
import style0 from "./levChart.vue?vue&type=style&index=0&id=04a841e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a841e6",
  null
  
)

export default component.exports